var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "#DE0043",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 11.9987H8.66732V10.6654H7.33398V11.9987ZM8.00065 1.33203C4.32065 1.33203 1.33398 4.3187 1.33398 7.9987C1.33398 11.6787 4.32065 14.6654 8.00065 14.6654C11.6807 14.6654 14.6673 11.6787 14.6673 7.9987C14.6673 4.3187 11.6807 1.33203 8.00065 1.33203ZM8.00065 13.332C5.06065 13.332 2.66732 10.9387 2.66732 7.9987C2.66732 5.0587 5.06065 2.66536 8.00065 2.66536C10.9407 2.66536 13.334 5.0587 13.334 7.9987C13.334 10.9387 10.9407 13.332 8.00065 13.332ZM8.00065 3.9987C6.52732 3.9987 5.33398 5.19203 5.33398 6.66536H6.66732C6.66732 5.93203 7.26732 5.33203 8.00065 5.33203C8.73398 5.33203 9.33398 5.93203 9.33398 6.66536C9.33398 7.9987 7.33398 7.83203 7.33398 9.9987H8.66732C8.66732 8.4987 10.6673 8.33203 10.6673 6.66536C10.6673 5.19203 9.47398 3.9987 8.00065 3.9987Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help_outline.770e1f0029c919f44ca630a3d35faefa.svg";
export { ForwardRef as ReactComponent };